import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
import ProduttivoMuiTheme from '../components/shared/themes/ProduttivoTheme';
import InvoiceNewContainer from './invoices/new/InvoiceNewContainer';

const invoicesNewErb = document.getElementById('invoices_create-container');

if (invoicesNewErb != null) {
  const root = createRoot(invoicesNewErb);

  root.render(
      <ThemeProvider theme={ProduttivoMuiTheme}>
        <InvoiceNewContainer />
      </ThemeProvider>
  );
}
